module.exports = __webpack_public_path__ + "img/pie-chart-active.427726b0.svg";